.SlideShow {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 5;
  top: 0;
  left: 0;
}

.SlideShowImage {
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  cursor: pointer;
  /* margin-top: 20%; */
}

.SlideShowClose {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 6;
}

@media (min-width: 1024px) or ((hover: hover) and (pointer: fine)) {
  .SlideShowClose {
    top: 54px;
  }
}

.InfoBlockSlideShow {
  display: flex;
  width: 100%;
  min-height: 151px;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: rgba(31, 30, 28, 0.6);
  backdrop-filter: blur(2px);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 7;
  color: var(--colori-neutri-white);
}

.InfoBlockSlideShowTitle {
  color: var(--colori-neutri-white);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.Municipality {
  color: var(--colori-neutri-white);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.PicturesCount {
  color: var(--colori-neutri-white);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 4px;
}

.Artist {
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 4px;
  color: white;
  padding-right: 8px;
  border-right: 2px solid white;
}

.PictureTitle {
  color: var(--colori-neutri-white);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.DateImage {
  color: var(--colori-neutri-white);
  text-align: center;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 8px;
  margin-top: 2px;
  border-right: 2px solid var(--colori-neutri-white);
  padding-right: 6px;
}

.License {
  color: var(--colori-neutri-white);
  margin-top: 4px;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
}

.Description {
  color: var(--colori-neutri-white);
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  margin-top: 4px;
  font-weight: 400;
  line-height: normal;
}

.Description > a {
  color: var(--colori-neutri-white);
  text-decoration: underline;
}

.ButtonCloseSlideshow {
  border-radius: 30px;
  background: var(--primary);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  margin-top: 8px;
  position: absolute;
  top: 0px;
  right: 0px;
  transition: all 0.3s ease-in-out;
}

.ButtonCloseSlideshow:hover {
  background: rgba(17, 138, 178, 0.8);
  cursor: pointer;
}

.CurrentImage {
  color: var(--colori-neutri-white);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 8px;
  margin-top: 2px;
  position: absolute;
  top: 30px;
  left: 16px;
  z-index: 7;
}

.PrevArrow {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 7;
  cursor: pointer;
}

.NextArrow {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 7;
  cursor: pointer;
}

@media (min-width: 1024px) or ((hover: hover) and (pointer: fine)) {
  .SlideShowImage {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    margin-top: 0%;
  }

  .CurrentImage {
    color: var(--colori-neutri-white);
    text-align: center;
    /* H2 */
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    margin-left: 8px;
    margin-top: 2px;
    position: absolute;
    top: auto;
    bottom: 120px;
    left: auto;
    right: 24px;
    transform: translateX(-50%);
    z-index: 7;
  }
}
